/* Pistacho — as medidas da ficha que esta no ar.

   Le a string do metafield, poe as medidas com nome, e guarda o desenho a
   escala atras de um botao: dentro da coluna da ficha nao ha largura para o
   mostrar, e no telemovel muito menos. Quem quer ver, ve em ecra inteiro.

   O desenho e o mesmo da ficha alternativa — vem de assets/pistacho-cotas.js.
   Aqui so se decide onde e quando aparece. */

(function () {
  'use strict';

  var C = window.PistachoCotas;
  if (!C) return;

  var raiz = document.querySelector('[data-pmed]');
  if (!raiz) return;
  var bruto = raiz.querySelector('[data-pmed-dados]');
  if (!bruto) return;

  var D;
  try { D = JSON.parse(bruto.textContent); } catch (e) { return; }

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  // Largura util de um elemento: o `clientWidth` INCLUI o padding, e medir o pai
  // com ele dava mais largura do que a que ha de facto. O desenho saia maior do
  // que o papel, o `max-width` encolhia-o depois, e com ele encolhia o tipo —
  // 10,5px onde tinham de ser 11,5. Desconta-se o padding.
  function larguraUtil(el) {
    if (!el) return 0;
    var cs = window.getComputedStyle(el);
    return el.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
  }


  var d = C.ler(D.medidas);
  // O desenho e feito quando o plano abre, ja com a largura a que vai ser
  // mostrado: o tipo e as folgas sao medidos em pixeis do ecra. Aqui so se
  // pergunta se ha desenho, para se saber o que dizer no botao.
  var temDesenho = !!C.desenhar(d, D.medidas, { larguraPx: 900 });
  var cotadas = D.cotadas || [];

  // Sem altura, largura e profundidade nao ha desenho — e ha pecas assim, os
  // candeeiros sobretudo. Nesse caso mostram-se as medidas com nome e mais nada,
  // que ja e melhor do que a linha corrida; se nem isso, fica tudo como estava.
  var chaves = ['L', 'P', 'A', 'C', 'Ø', 'E'].filter(function (k) { return d[k]; });
  if (!chaves.length) return;

  var lista = raiz.querySelector('[data-pmed-lista]');
  lista.innerHTML = chaves.map(function (k) {
    return '<div><dt>' + C.ROTULOS[k] + '</dt><dd>' + C.mm(d[k]) + '<span>mm</span></dd></div>';
  }).join('');
  lista.hidden = false;

  // A cauda da string (o pufe, a consola, a altura do assento) escreve-se como
  // esta escrita: nao se interpreta o que nao e preciso interpretar.
  var cauda = C.detalhes(D.medidas);
  if (cauda.length) {
    var elC = raiz.querySelector('[data-pmed-cauda]');
    elC.textContent = cauda.join('. ') + '.';
    elC.hidden = false;
  }

  raiz.setAttribute('data-pronto', '');

  // 4-11 (Pedro): sai o botão do desenho à escala; só fica o do desenho cotado.
  if (temDesenho || !cotadas.length) return;

  var botao = raiz.querySelector('[data-pmed-abrir]');
  var rot = raiz.querySelector('[data-pmed-abrir-t]');
  if (rot && !temDesenho) rot.textContent = cotadas.length > 1
    ? (rot.getAttribute('data-t-cotados') || 'Ver os desenhos cotados')
    : (rot.getAttribute('data-t-cotado') || 'Ver o desenho cotado');
  botao.hidden = false;

  var plano = null, antes = null, redesenhar = null, aEsperar = null;

  function aoMudar() {
    clearTimeout(aEsperar);
    aEsperar = setTimeout(function () { if (redesenhar) redesenhar(); }, 180);
  }

  function fechar() {
    if (!plano) return;
    window.removeEventListener('resize', aoMudar);
    redesenhar = null;
    plano.remove();
    plano = null;
    document.documentElement.style.overflow = '';
    if (antes && antes.focus) antes.focus();
  }

  function abrir() {
    if (plano) return;
    antes = document.activeElement;

    // Os desenhos cotados vem primeiro quando existem: sao os desenhos a serio,
    // feitos peca a peca, e ja estao na galeria de 76 das 127 pecas. O esquema
    // gerado e a envolvente — util pela porta a mesma escala, que os cotados nao
    // tem, mas e uma caixa. Mostrar a caixa antes do desenho verdadeiro era pôr
    // o pior primeiro.
    var corpo = '';
    if (cotadas.length) {
      corpo += '<div class="pmed-plano__cot">' + cotadas.map(function (c, i) {
        return '<img src="' + esc(c.url) + '" loading="lazy" alt="Desenho cotado da ' +
          esc(D.titulo) + ', vista ' + (i + 1) + ' de ' + cotadas.length + ', com as medidas em milímetros.">';
      }).join('') + '</div>';
    }
    if (temDesenho) {
      corpo += '<p class="pmed-plano__leg' + (cotadas.length ? ' pmed-plano__leg--depois' : '') +
        '">O contorno é o espaço que a peça ocupa, à escala. ' +
        (d.P ? 'A porta ao lado está à mesma escala.' : 'A régua em baixo dá a medida.') + '</p>' +
        '<div class="pmed-plano__cx"></div>';
    }

    plano = document.createElement('div');
    plano.className = 'pmed-plano';
    plano.setAttribute('role', 'dialog');
    plano.setAttribute('aria-modal', 'true');
    plano.setAttribute('aria-label', 'Medidas de ' + D.titulo);
    plano.innerHTML =
      '<div class="pmed-plano__topo">' +
        '<p class="pmed-plano__t">' + esc(D.titulo) + ' — medidas</p>' +
        '<button type="button" class="pmed-plano__x" aria-label="Fechar">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">' +
          '<path d="M6 6l12 12M18 6L6 18"></path></svg>' +
        '</button>' +
      '</div>' +
      '<div class="pmed-plano__corpo">' + corpo + '</div>';

    document.body.appendChild(plano);
    document.documentElement.style.overflow = 'hidden';
    // O desenho so agora, com a caixa ja medida — e outra vez se a janela mudar.
    var cx = plano.querySelector('.pmed-plano__cx');
    if (cx) {
      // Mede-se o PAI, nao a folha: a folha encolhe para o desenho, e uma folha
      // vazia tem largura zero — media-se zero e nao se desenhava nada.
      var feitoA = 0;
      redesenhar = function () {
        if (!plano || !cx) return;
        var disp = Math.round(larguraUtil(cx.parentNode));
        if (disp < 120) return;
        var alvo = Math.min(disp, 820);
        var w = alvo - 36;                        // 18px de papel de cada lado
        if (w < 150 || Math.abs(w - feitoA) < 8) return;
        feitoA = w;
        var novo = C.desenhar(d, D.medidas, { larguraPx: w });
        if (!novo) return;
        cx.innerHTML = novo;
        var med = /width:(\d+)px/.exec(novo);
        cx.style.width = (med ? (+med[1] + 36) : alvo) + 'px';
      };
      redesenhar();
      window.addEventListener('resize', aoMudar);
    }

    plano.querySelector('.pmed-plano__x').addEventListener('click', fechar);
    plano.addEventListener('click', function (e) { if (e.target === plano) fechar(); });
    plano.querySelector('.pmed-plano__x').focus();
  }

  botao.addEventListener('click', abrir);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechar(); });
}());
